import React from "react";
import { ActionButton, PanelShell, Pill, StatusBadge } from "./ResultsPrimitives.jsx";

export default function InvalidStopsPanel({ interactions = {}, model = {} }) {
  const items = Array.isArray(model.items) ? model.items : [];

  return (
    <PanelShell
      eyebrow="Arrêts invalides"
      title="Clients non routables"
      actions={<Pill tone="danger">{model.countLabel}</Pill>}
      className="rounded-[18px] border border-[rgba(197,82,74,0.22)] bg-[linear-gradient(180deg,rgba(255,248,247,0.98),rgba(255,255,255,0.98))] px-3 py-3 shadow-[inset_0_1px_0_rgba(255,255,255,0.74),0_10px_24px_rgba(10,32,37,0.05)]"
      bodyClassName="grid gap-2"
    >
      <div className="grid gap-2" data-route-target-invalid-stop-list="true">
        {items.map((item) => (
          <article
            key={item.key}
            className="grid gap-2 rounded-[16px] border border-[rgba(197,82,74,0.16)] bg-[rgba(255,246,245,0.96)] px-4 py-3"
          >
            <div className="flex flex-wrap items-center justify-between gap-3">
              <strong className="text-[0.92rem] font-semibold text-text">{item.title}</strong>
              <StatusBadge tone={item.badgeTone}>{item.badgeLabel}</StatusBadge>
            </div>
            <p className="m-0 text-[0.84rem] leading-6 text-muted-strong">{item.address}</p>
            {item.warningMessage ? (
              <small className="text-[0.78rem] leading-6 text-muted">{item.warningMessage}</small>
            ) : null}
            {item.errorEntryId ? (
              <ActionButton
                tone="ghost"
                size="sm"
                className="justify-self-start"
                onClick={() => {
                  interactions.onOpenError?.({
                    errorId: item.errorEntryId,
                    filter: "non_assignable_orders",
                    source: "invalid_stop",
                  });
                }}
              >
                Ouvrir l&apos;erreur
              </ActionButton>
            ) : null}
          </article>
        ))}
      </div>
    </PanelShell>
  );
}